import React, {useEffect, useState} from 'react';
import Footer from "../layout/Footer";
import { useLocalStorage } from "../useLocalStorage";
import "./Profile.css";
import Swal from 'sweetalert2';
import toast, { Toaster } from 'react-hot-toast';
import M from "materialize-css";
import $ from "jquery";

import banner1 from "../logo.svg"
import { API_URL, numberWithCommas } from '../constant';

import jwt  from 'jsonwebtoken';
import HeaderBack from '../layout/HeaderBack';


import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import Stack from '@mui/material/Stack';
import { Backdrop, CircularProgress } from '@mui/material';


const NetworkTree = ()=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [period, setPeriod] = useState('');
    const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);
    
    const notify = () => toast.error('Something went wrong!');

    function LogoutHandler(event){
        Swal.fire({
            title: "Log Out",
            text: "Are you want to log out from this application?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#ff3d00',
            cancelButtonColor: '#d33',
            confirmButtonText: `Yes, I'm sure!`
        }).then((result)=>{
            if(result.isConfirmed){
                setToken("");
                window.location = '/';
            }
        })
    }
    async function downloadHandler(){
        setIsOpenBackdrop(true);
        if(period != "" ){
            $("#btn-download").attr("disabled","disabled");
            let response = await getTree(period.getFullYear(), period.getMonth()+1);
            $("#btn-download").removeAttr("disabled");
            if(response){
                if(response.status == 200){
                    $("#download").attr("href",`https://shop.moorlife.id/${response.data}`);
                    document.getElementById("download").click();
                }
                else{
                    toast.error(response.message)
                }
            }else{
                notify();
            }
        }else{
            toast.error("All field is required!")
        }
        setIsOpenBackdrop(false);
        
    }

    function getTree(year, month){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/networktree/${year}/${month}`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }

    useEffect(async ()=>{
        let el = document.querySelectorAll(".datepicker");
        let options = {
            format: 'mmmm yyyy',
            onClose: async function(){
                let d = this.date
                $("#download").attr("disabled", "disabled");
                if(d){
                    let response = await getTree(d.getFullYear(), d.getMonth() + 1);
                    if(response){
                        response = JSON.parse(response);
                        if(response.status == 200){
                            $("#download").removeAttr("disabled");
                            $("#download").attr("href", `https://shop.moorlife.id/${response.data}`);
                        }
                    }else{
                        notify();
                    }
                }
            }
        };
        var instance = M.Datepicker.init(el, options);
    },[]);


    return(
        <React.StrictMode>
            <Toaster
                position="bottom-center"
            />
            <HeaderBack title="Network Tree" />
            <div className=''>
                <div className='row' style={{"marginTop":"15px"}}>
                    <div className='col s4'>
                        <h6 style={{"fontSize":"16pt"}}>Period</h6>
                    </div>
                    <div className='col s8'>
                        <Stack spacing={3}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <MobileDatePicker
                                    views={['year', 'month']}
                                    label="Year and Month"
                                    value={period}
                                    onChange={async (newValue) => {
                                        let d = newValue
                                        // $("#download").attr("disabled", "disabled");
                                        // if(d){
                                        //     let response = await getTree(d.getFullYear(), d.getMonth() + 1);
                                        //     if(response){
                                        //         response = JSON.parse(response);
                                        //         if(response.status == 200){
                                        //             $("#download").removeAttr("disabled");
                                        //             $("#download").attr("href", `https://shop.moorlife.id/${response.data}`);
                                        //         }
                                        //     }else{
                                        //         notify();
                                        //     }
                                        // }
                                        setPeriod(newValue);
                                    }}
                                    renderInput={(params) => <TextField {...params} helperText={null} />}
                                />
                            </LocalizationProvider>
                        </Stack>
                        {/* <input type="text" className="datepicker" id="PeriodDate"/> */}
                    </div>
                </div>
                <div className='row'>
                    <div className='col s6'>
                        <a href="#" className='btn' id="btn-download" onClick={()=>downloadHandler()}><i className="material-icons">file_download</i> <span>Download</span></a>
                        <a style={{"display":"none"}} download id="download" target="_blank">redirect</a>
                    </div>
                </div>
            </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isOpenBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
        </React.StrictMode>
    );
}

export default NetworkTree;
